import gettext from '@sdk/lang/gettext';
import TranslateWithComponents from '@sdk/lang/TranslateWithComponents';
import { ThemeColorType } from 'sling-sdk/src/theme/ThemeColorType';
import useConfig from '@sdk/config/useConfig';

import { useArticleSearchContext } from '@web/newsfeed/ArticleSearch/ArticleSearchProvider/ArticleSearchProvider';

import { SearchDescriptionText, SearchDescriptionWrapper } from './articleSearchHeader.style';

export const ArticleSearchHeader = () => {
  const {
    FEATURE_FLAGS: { ARTICLE_SEARCH_BY_PAGE },
  } = useConfig();
  const { searchQuery, page } = useArticleSearchContext();

  return (
    <SearchDescriptionWrapper>
      <SearchDescriptionText>
        <TranslateWithComponents
          replaceComponents={{
            searchQueryComponent: (
              <SearchDescriptionText themeColor={ThemeColorType.primary}>
                {searchQuery}
              </SearchDescriptionText>
            ),
            pageNameComponent: <SearchDescriptionText semiBold>{page?.name}</SearchDescriptionText>,
          }}>
          {ARTICLE_SEARCH_BY_PAGE && page.id !== 0
            ? gettext('Search results for [[searchQueryComponent]] in [[pageNameComponent]]')
            : gettext('Search results for [[searchQueryComponent]] in all pages')}
        </TranslateWithComponents>
      </SearchDescriptionText>
    </SearchDescriptionWrapper>
  );
};
